/** Retourne l'icône et la couleur associées à une extension de fichier */

import { FileSVG } from '../../@common_components/svgs/file.svg';

interface FileTypeIconProps {
  extension?: string | null;
  className?: string;
}

interface FileTypeConfig {
  color: string;
  label: string;
  path: string;
  viewBox: string;
}

const GENERIC_FILE_PATH = 'M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z';
const GENERIC_FILE_VIEWBOX = '0 0 384 512';

const FILE_TYPES: Record<string, FileTypeConfig> = {
  /* PDF */
  pdf: { color: 'text-gray-400', label: 'PDF', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Word */
  doc: { color: 'text-blue-600',   label: 'DOC',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  docx: { color: 'text-blue-600',   label: 'DOCX', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Excel */
  xls: { color: 'text-green-600',  label: 'XLS',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  xlsx: { color: 'text-green-600',  label: 'XLSX', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  csv: { color: 'text-green-500',  label: 'CSV',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* PowerPoint */
  ppt: { color: 'text-orange-500', label: 'PPT',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  pptx: { color: 'text-orange-500', label: 'PPTX', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Images */
  png: { color: 'text-purple-500', label: 'PNG',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  jpg: { color: 'text-purple-500', label: 'JPG',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  jpeg: { color: 'text-purple-500', label: 'JPEG', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  gif: { color: 'text-purple-400', label: 'GIF',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  svg: { color: 'text-purple-400', label: 'SVG',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  webp: { color: 'text-purple-400', label: 'WEBP', viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Vidéo */
  mp4: { color: 'text-slate-700',  label: 'MP4',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  mov: { color: 'text-slate-700',  label: 'MOV',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  avi: { color: 'text-slate-700',  label: 'AVI',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Audio */
  mp3: { color: 'text-yellow-500', label: 'MP3',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  wav: { color: 'text-yellow-500', label: 'WAV',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Archives */
  zip: { color: 'text-amber-700',  label: 'ZIP',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  rar: { color: 'text-amber-700',  label: 'RAR',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
  /* Texte */
  txt: { color: 'text-gray-500',   label: 'TXT',  viewBox: GENERIC_FILE_VIEWBOX, path: GENERIC_FILE_PATH },
};

const DEFAULT_CONFIG: FileTypeConfig = {
  color: 'text-gray-400',
  label: '—',
  viewBox: GENERIC_FILE_VIEWBOX,
  path: GENERIC_FILE_PATH,
};

export function FileTypeIcon( { extension, className }: FileTypeIconProps ) {
  const raw = ( extension ?? '' ).toString();
  const ext = raw.replace( /^\./, '' ).toLowerCase();
  const config = FILE_TYPES[ ext ] ?? DEFAULT_CONFIG;

  return (
    <div className={ `relative inline-flex items-center justify-center ${ className ?? '' }` }>
      <FileSVG viewBox={ config.viewBox } path={ config.path } className={ `w-full h-full ${ config.color }` } fill="currentColor" />
      <span className="absolute bottom-[18%] left-0 right-0 text-center text-white font-bold leading-none" style={ { fontSize: '0.5em' } }>
        { config.label }
      </span>
    </div>
  );
}
